import React, { useEffect, useState } from "react";

const LINES = [
  "I help shape ideas before they become productions.",
  "Every great production begins with one honest conversation.",
  "One sentence in. A creative direction, an honest budget and a real plan out.",
  "I think in strategy, story, budgets and shoot days, all at once.",
  "I remember every conversation. You never explain twice.",
  "Great productions aren\u2019t bigger. They\u2019re better planned.",
  "I see the production before the cameras roll.",
  "Clarity saves more money than compromise.",
  "Ideas deserve great execution.",
  "Every frame starts with the right conversation.",
];

// The landing hero's living proof of intelligence. The dot is the fixed
// anchor; only the sentence breathes. The layout never shifts.
export const HeroIntelligence = () => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % LINES.length);
        setVisible(true);
      }, 420);
    }, 4600);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className="w-full flex flex-col items-center px-4"
      data-testid="hero-intelligence"
    >
      <span className="relative flex h-2 w-2 shrink-0" aria-hidden>
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E53935]/50" style={{ animationDuration: "2.4s" }} />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#E53935]" />
      </span>
      <div className="mt-2.5 h-[46px] md:h-[27px] flex items-start justify-center w-full">
        <p
          className="font-serif-italic text-muted-ink text-[15px] md:text-[17px] leading-[1.5] max-w-[560px] text-center transition-[opacity,transform] duration-[420ms] ease-out"
          style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(4px)" }}
          data-testid="hero-intelligence-line"
        >
          {LINES[idx]}
        </p>
      </div>
    </div>
  );
};

export default HeroIntelligence;
